import React from 'react';
import { Link } from 'react-router-dom';
import { BsArrowRight } from 'react-icons/bs';
import { useCMS } from '../../context/CMSContext';

const GlobalCta = () => {
  const { getSection } = useCMS();
  const ctaCMS = getSection('cta', {
    tag: "LET'S BUILD TOGETHER",
    heading: "Ready to Grow Your Business Digitally?",
    description: "From websites to AI solutions, we've got you covered.",
    primaryBtnText: "Start Your Project",
    primaryBtnLink: "/contactus"
  });

  return (
    <section className="py-14 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Rounded Gradient Banner matching mockup */}
        <div 
          className="relative overflow-hidden bg-gradient-to-r from-[#ff6200] via-[#ff7800] to-[#ffa300] rounded-3xl p-8 sm:p-12 md:p-14 text-white shadow-2xl shadow-orange-500/25 flex flex-col md:flex-row md:items-center justify-between gap-8"
          data-aos="zoom-in"
        >
          {/* Subtle Ambient Light Shimmer */}
          <div className="absolute -right-16 -top-16 w-80 h-80 bg-white/10 rounded-full blur-2xl pointer-events-none"></div>

          {/* Left Content */}
          <div className="space-y-3 max-w-xl relative z-10">
            
            {/* Tag */}
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-sm bg-white"></span>
              <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-white/90">
                {ctaCMS.tag || "LET'S BUILD TOGETHER"}
              </span>
            </div>

            {/* Heading */}
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-white tracking-tight leading-snug">
              {ctaCMS.heading || "Ready to Grow Your Business Digitally?"}
            </h2>

            {/* Subtitle */}
            <p className="text-white/90 text-sm sm:text-base font-normal leading-relaxed">
              {ctaCMS.description || "From websites to AI solutions, we've got you covered."}
            </p>

          </div>

          {/* Right Action Button */}
          <div className="relative z-10 shrink-0">
            <Link to={ctaCMS.primaryBtnLink || "/contactus"}>
              <button className="bg-white hover:bg-orange-50 text-[#f06600] font-bold px-7 sm:px-8 py-3.5 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 flex items-center justify-center gap-2 text-xs sm:text-sm tracking-wide cursor-pointer group">
                <span>{ctaCMS.primaryBtnText || "Start Your Project"}</span>
                <BsArrowRight className="text-base group-hover:translate-x-1 transition-transform" />
              </button>
            </Link>
          </div>

        </div>

      </div>
    </section>
  );
};

export default GlobalCta;

